import moment from 'moment';
import ReactGA from 'react-ga4';

import { EVENT_TYPE_SAMPLE } from '../constants';
import { Event } from '../types';
import { getSampleSuffix } from '../utils';

export const trackCreateProject = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'click_create_project',
    label: source,
  });
};

export const trackCreateProjectError = () => {
  ReactGA.event({
    category: 'User',
    action: 'create_project_error',
  });
};

export const trackOpenProject = (source: string, event: Event) => {
  ReactGA.event({
    category: 'User',
    action: `open_project_from_${source}`,
    label: `${event.eventId} – ${event.name} (${event.type})`,
  });
};

export const trackProjectComplete = (event: Event) => {
  const isSample = event.type === EVENT_TYPE_SAMPLE;
  const timestampMills = moment(new Date()).valueOf();

  ReactGA.event({
    category: 'User',
    action: `project_complete${getSampleSuffix(isSample)}`,
    label: `${event.eventId} – ${event.name} (${event.type})`,
    value: timestampMills,
  });
};

export const trackFirstProjectComplete = (event: Event) => {
  const isSample = event.type === EVENT_TYPE_SAMPLE;
  const timestampMills = moment(new Date()).valueOf();

  ReactGA.event({
    category: 'User',
    action: `first_project_complete${getSampleSuffix(isSample)}`,
    label: `${event.eventId} – ${event.name} (${event.type})`,
    value: timestampMills,
  });
};

// PROJECT SETTINGS

export const trackEditProject = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'click_edit_project',
    label: source,
  });
};

export const trackEditProjectChangeImg = (type: string) => {
  ReactGA.event({
    category: 'User',
    action: `edit_project_change_${type}`,
  });
};

export const trackUpdateProjectSuccess = () => {
  ReactGA.event({
    category: 'User',
    action: 'update_project_success',
  });
};

export const trackUpdateProjectError = () => {
  ReactGA.event({
    category: 'User',
    action: 'update_project_error',
  });
};

export const trackUpdateNameSuccess = () => {
  ReactGA.event({
    category: 'User',
    action: 'update_name_success',
  });
};

export const trackUpdateNameError = () => {
  ReactGA.event({
    category: 'User',
    action: 'update_name_error',
  });
};

// email hub

export const trackEmailHubClickPreview = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_click_preview',
    label: source,
  });
};

export const trackEmailHubClickTestEmail = () => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_click_test_email',
  });
};

export const trackEmailHubSendTestEmailSuccess = (count: number) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_send_test_email_success',
    label: count.toString(),
  });
};

export const trackEmailHubSendTestEmailError = (count: number) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_send_test_email_error',
    label: count.toString(),
  });
};

export const trackEmailHubClickChange = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_click_change',
    label: source,
  });
};

export const trackEmailHubChangeTemplateSuccess = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_change_template_success',
    label,
  });
};

export const trackEmailHubChangeTemplateError = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_change_template_error',
    label,
  });
};

export const trackEmailHubClickCustomText = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_click_custom_text',
    label,
  });
};

export const trackEmailHubUpdateCustomTextSuccess = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_update_custom_text_success',
    label,
  });
};

export const trackEmailHubUpdateCustomTextError = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_hub_update_custom_text_error',
    label,
  });
};

// PROJECT ANALYTICS

export const trackClickProjectAnalytics = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'click_project_analytics',
    label: source,
  });
};

// ASSETS

export const trackCheckInQRDownload = (source: string) => {
  ReactGA.event({
    category: 'User',
    action: 'check_in_qr_download',
    label: source,
  });
};
